export default __webpack_public_path__ + "74935601ff738e27b164ca91a2b14714.png";